if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');
      const initialSlide = this.querySelector('.custom-announcement-0')
      initialSlide.classList.add('active-announcement')
      

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

       //Added autoplay to announcement bar
      if(this.length > 1){
        this._initAutoplay();
      }
        
      
    }

    changeSlide(direction) {
       //Added autoplay to announcement bar
      const prevSlide = this.querySelector('.custom-announcement-' + this.index)
      prevSlide.classList.remove('active-announcement')
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length ) {
         //Added autoplay to announcement bar
        this.index = 0;
        //this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }
      const nextSlide = this.querySelector('.custom-announcement-' + this.index)
      nextSlide.classList.add('active-announcement')

      //Removed slide to left when going back to first index 
      /*
        this.slider.scrollTo({
          top: 0,
          left: this.content[this.index].offsetLeft,
          behavior: 'smooth'
       });
      */

    }

    //Added autoplay to announcement bar
    _initAutoplay(){
      if ( this._autoplayInterval ) {
        clearInterval(this._autoplayInterval);
      }
      this._autoplayInterval = setInterval(()=>{
          this.changeSlide('next');
      }, 5000);
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}